<div class="al-overlay" (click)="cancel()">
  <div class="al-modal" (click)="$event.stopPropagation()">
    <header class="al-head">
      <div class="al-head-titleblock">
        <h2 class="al-title" *ngIf="view === 'edit'">Performance alerts</h2>
        <h2 class="al-title" *ngIf="view === 'copy'">Copy alert config to other performances</h2>
        <p class="al-sub" *ngIf="view === 'edit'">{{ performance.description || 'Performance' }}</p>
        <p class="al-sub" *ngIf="view === 'copy'">Pick performances at this venue to copy {{ emails.length }} email recipient{{ emails.length === 1 ? '' : 's' }} to. Existing recipients on those performances will be replaced.</p>
      </div>
      <button type="button" class="al-close" (click)="cancel()" [disabled]="saving || copyRunning" aria-label="Close">✕</button>
    </header>

    <div class="al-body" *ngIf="view === 'edit'">
      <div class="al-loading" *ngIf="loading">Loading…</div>

      <div class="al-stopgap-banner" *ngIf="!loading">
        <strong>Heads up:</strong> alerts trigger when a <em>scheduled scan test</em> result doesn't match its expected value — not when a stage deadline is missed. Per-stage time alerts will arrive once the backend supports them.
      </div>

      <ng-container *ngIf="!loading && !loadError">
        <div class="al-section">
          <header class="al-section-head">
            <span class="al-section-title">Recipient emails</span>
            <span class="al-section-meta">{{ emails.length }} recipient{{ emails.length === 1 ? '' : 's' }}</span>
          </header>

          <div class="al-email-list">
            <div class="al-email-row" *ngFor="let email of emails; trackBy: trackEmail">
              <span class="al-email-text">{{ email }}</span>
              <button type="button"
                      class="al-email-remove"
                      [disabled]="saving"
                      appTooltip="Remove"
                      (click)="removeEmail(email)">✕</button>
            </div>
            <div class="al-email-empty" *ngIf="!emails.length">No recipients yet — add at least one to receive alerts.</div>
          </div>

          <div class="al-email-add">
            <input type="email"
                   class="al-email-input"
                   [class.input-error]="!!emailDraftError"
                   placeholder="name@example.com"
                   [(ngModel)]="emailDraft"
                   (keyup.enter)="addEmail()"
                   [disabled]="saving" />
            <button type="button"
                    class="al-btn al-btn-secondary"
                    (click)="addEmail()"
                    [disabled]="saving">Add</button>
          </div>
          <p class="al-error" *ngIf="emailDraftError">{{ emailDraftError }}</p>
        </div>
      </ng-container>

      <p class="al-error" *ngIf="loadError">{{ loadError }}</p>
    </div>

    <div class="al-body" *ngIf="view === 'copy'">
      <div class="al-loading" *ngIf="copyLoading">Loading other performances…</div>

      <div class="al-target-list" *ngIf="!copyLoading && copyTargets.length">
        <div class="al-target-head">
          <label class="al-target-row al-target-row--head">
            <input type="checkbox"
                   [checked]="allTargetsSelected"
                   [disabled]="copyRunning"
                   (change)="toggleAllTargets()" />
            <span class="al-target-label">Performance</span>
            <span class="al-target-meta">{{ selectedTargets.size }} of {{ copyTargets.length }} selected</span>
          </label>
        </div>
        <div class="al-target-scroll">
          <label class="al-target-row"
                 *ngFor="let t of copyTargets; trackBy: trackTarget"
                 [class.al-target-row--selected]="isTargetSelected(t)"
                 [class.al-target-row--done]="t.status === 'done'"
                 [class.al-target-row--saving]="t.status === 'saving'"
                 [class.al-target-row--error]="t.status === 'error'">
            <input type="checkbox"
                   [checked]="isTargetSelected(t)"
                   [disabled]="copyRunning"
                   (change)="toggleTarget(t)" />
            <div class="al-target-text">
              <div class="al-target-name">{{ t.description || 'Untitled performance' }}</div>
              <div class="al-target-date">{{ t.date }}</div>
            </div>
            <span class="al-target-chip al-target-chip--warn" *ngIf="t.hasEmails && t.status !== 'done'">has recipients · will replace</span>
            <span class="al-target-chip al-target-chip--saving" *ngIf="t.status === 'saving'">copying…</span>
            <span class="al-target-chip al-target-chip--done" *ngIf="t.status === 'done'">copied ✓</span>
            <span class="al-target-chip al-target-chip--error" *ngIf="t.status === 'error'" [appTooltip]="t.error || ''">failed</span>
          </label>
        </div>
      </div>

      <div class="al-target-empty" *ngIf="!copyLoading && !copyTargets.length">No other performances at this venue to copy to.</div>
    </div>

    <footer class="al-foot">
      <p class="al-error" *ngIf="saveError">{{ saveError }}</p>
      <p class="al-error" *ngIf="copyError">{{ copyError }}</p>

      <div class="al-foot-actions" *ngIf="view === 'edit'">
        <button type="button" class="al-btn al-btn-cancel" [disabled]="saving" (click)="cancel()">Cancel</button>
        <button type="button"
                class="al-btn al-btn-secondary"
                *ngIf="emails.length"
                [disabled]="saving"
                appTooltip="Copy these recipients to other performances at this venue"
                (click)="enterCopyView()">Copy to other performances…</button>
        <button type="button"
                class="al-btn al-btn-save"
                [disabled]="saving || loading"
                (click)="save()">
          {{ saving ? 'Saving…' : 'Save alerts' }}
        </button>
      </div>

      <div class="al-foot-actions" *ngIf="view === 'copy'">
        <button type="button" class="al-btn al-btn-cancel" [disabled]="copyRunning" (click)="exitCopyView()">{{ copyDone ? 'Back' : 'Cancel' }}</button>
        <button type="button"
                class="al-btn al-btn-save"
                *ngIf="!copyDone"
                [disabled]="copyRunning || copyLoading || !selectedTargets.size"
                (click)="confirmCopy()">
          {{ copyRunning
              ? 'Copying…'
              : ('Copy to ' + (selectedTargets.size || '0') + ' performance' + (selectedTargets.size === 1 ? '' : 's')) }}
        </button>
      </div>
    </footer>
  </div>
</div>
